module.exports = __webpack_public_path__ + "static/media/LinkedIn Avatar_1715249481259.7ec84db6.png";